import React from 'react';
import { Menu, MenuItem, Button } from '@material-ui/core';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { CustomMenuSelect } from '../../../../shared/custom-menu-select/CustomMenuSelect';
import { ACTIVITY_FILTER_LIST } from '../../../../constants/ActivityCalendarConst';
import { KeyboardArrowUp } from '@material-ui/icons';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropDown';

const ActivityFilter = ({
  showFilter,
  setShowFilter,
  anchorEl,
  handleFilterResult,
  setActiveFilterName,
  showActiveFilterName,
  handleResetlist,
  isCalendarview = false,
  filterOptions,
  handleShowFilter,
  handleSelectFilter,
  subFilterAnchorEl,
  menuPositionOverride,
  subMenuPositionOverride,
}) => {
  return (
    <div className='kebab-menu px-2'>
      <Button
        aria-controls='simple-menu'
        aria-haspopup='true'
        className={
          filterOptions?.some((filter) => filter?.selectedCount > 0)
            ? 'filterButton'
            : 'dropdown-button'
        }
        size='medium'
        variant='outlined'
        color='secondary'
        disableRipple
        endIcon={showFilter ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        onClick={(e) => handleShowFilter(e)}
      >
        Filter
      </Button>
      <Menu
        id={'activityFilter'}
        anchorEl={anchorEl}
        keepMounted
        open={showFilter}
        className='shadow menuSection'
        onClose={() => {
          setShowFilter(false);
          setActiveFilterName({ name: '', id: '' });
          document?.activeElement?.blur();
        }}
        anchorOrigin={menuPositionOverride?.anchorOrigin || { vertical: 'top', horizontal: 'left' }}
        transformOrigin={
          menuPositionOverride?.transformOrigin || { vertical: 'top', horizontal: 'left' }
        }
      >
        {[...ACTIVITY_FILTER_LIST]?.map((date, index) => {
          const selectedCount =
            filterOptions?.find((filter) => filter?.id === date?.id)?.selectedCount || 0;
          return (
            <MenuItem
              key={date?.id}
              value={date?.id}
              className='menuList'
              name={date?.name}
              isActive={date?.name === showActiveFilterName?.name}
              onClick={(e) => handleSelectFilter(e?.currentTarget, index)}
            >
              <div className='menu-item-content'>
                <span>{date?.name}</span>
                <div className='menu-item-right'>
                  {selectedCount > 0 && <div className='filter-count-badge'>{selectedCount}</div>}
                  {date?.isSubCategory && <ChevronRightIcon fontSize='small' />}
                </div>
              </div>
            </MenuItem>
          );
        })}
        <MenuItem className='clearfilter' onClick={handleResetlist}>
          <span> </span>
          <span>Clear</span>
        </MenuItem>
      </Menu>
      {filterOptions?.map(({ id, options, setOptions, filterKey, isShowAll, isShowAllSearch }) => (
        <CustomMenuSelect
          key={id}
          anchorEl={subFilterAnchorEl}
          isOpen={showActiveFilterName?.id === id}
          options={options}
          handleClose={() => setActiveFilterName({ name: '', id: '' })}
          handleValue={(value) => {
            setOptions(value);
            handleFilterResult(filterKey, value);
          }}
          isShowAll={isShowAll}
          className={isCalendarview ? 'subCategorySection' : 'list-view'}
          isShowAllSearch={isShowAllSearch}
          handleResetList={handleResetlist}
          subMenuPositionOverride={subMenuPositionOverride}
        />
      ))}
    </div>
  );
};

export default ActivityFilter;
